import { HttpStatusCodeType } from '~/enums/HttpStatusCodeType';
import { testIsAxiosError } from '~/redux/api/utils';

import { isAccessControlMockFallbackEnabled } from './shouldUseAccessControlMock';

/**
 * Runs `request`; if it 404s (the real endpoint isn't implemented yet) and the
 * mock fallback is opted into via `isAccessControlMockFallbackEnabled`, runs
 * `mockFallback` instead. Any other error (403, 500, network failure) still
 * propagates so real failures aren't masked.
 */
export async function withAccessControlMockFallback<T>(
  request: () => Promise<T>,
  mockFallback: () => T,
): Promise<T> {
  try {
    return await request();
  } catch (error) {
    const isNotFound =
      testIsAxiosError(error) &&
      error.response?.status === HttpStatusCodeType.NotFound;

    if (isNotFound && isAccessControlMockFallbackEnabled()) {
      return mockFallback();
    }

    throw error;
  }
}
